import { useEffect } from 'react';
import { DrawerPortals } from './DrawerPortals';
import { useDrawerStore } from '../useDrawerStore';
import { useCloseAllDrawersExpectMenu } from '../useCloseAllDrawersExpectMenu';

/**
 * Use ChildrenCreateDrawerStore when you need to wrap drawer into context @see ProductionPlans.tsx for example
 */
export const ChildrenDrawerPortals = () => {
  const setIsChildrenProviderMounted = useDrawerStore((state) => state.setIsChildrenProviderMounted);

  useEffect(() => {
    setIsChildrenProviderMounted(true);

    return () => {
      setIsChildrenProviderMounted(false);
    };
  });

  useCloseAllDrawersExpectMenu();

  return <DrawerPortals />;
};
